export default __webpack_public_path__ + "static/media/support-team-alice.2a94aa11.png";